const VALIDATION = {
    password_min_length: 8,
};

export default VALIDATION;
